import { useEffect, useState } from 'react';
import useAxios from 'axios-hooks';
import {
  Spinner,
  Flex,
  Image,
  Spacer,
  Text
} from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

import homeIcon from '../../../../assets/dashboard/Frame120.svg';
import {
  API_ENDPOINTS
} from '../../../../utils';

type TServiceDiscoveryProps = {
  onUpdate: Function;
};

function ServiceDiscovery ({ onUpdate }: TServiceDiscoveryProps) {
  const [{ data, loading }, refetchStatus] = useAxios(API_ENDPOINTS.EMAIL_PROCESSING);
  const [discoveryStatus, setDiscoveryStatus] = useState<any>({
    total: 0,
    finished: true
  });

  useEffect(() => {
    if (data && data.emailProcessingStatus.length) {
      const emails = data.emailProcessingStatus.map((email: any) => email[Object.keys(email)[0]]);

      const pending = emails.filter((email: any) => email.status === 'processing');

      if (discoveryStatus.total !== data.discoveredProviders.length) onUpdate();

      setDiscoveryStatus({
        total: data.discoveredProviders.length,
        finished: pending.length === 0
      });
    }

    if (!loading && !discoveryStatus.finished) {
      setTimeout(refetchStatus, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loading, discoveryStatus]);

  if (discoveryStatus.finished) return null;

  return (
    <Flex alignItems='center' width='100%' h={'60px'} pr='20px' pl='5px' backgroundColor='#FFDB80'>
      <Image width='60px' padding='10px' src={homeIcon} />
      <Text fontWeight={{ sm: '500' }} fontSize={{ sm: 'xs', md: 'md' }}>{`${discoveryStatus.total} Service${discoveryStatus.total > 1 || discoveryStatus.total === 0 ? 's' : ''} discovered from ${data.emailProcessingStatus.length} email address(es).`}</Text>
      <Spacer />
      {discoveryStatus.finished ? <CheckIcon color='green' /> : <Spinner colorScheme='purple' />}
    </Flex>
  );
}

export default ServiceDiscovery;
